import {FC, useMemo} from 'react';
import {styled} from 'styled-components';

import {useStringArrayQueryString} from '@shared-web/lib/use_query_string';

import {ChampionCard} from '@src/components/champion_card';
import {CHAMPIONS} from '@src/lib/champions';
import {Team} from '@src/lib/teams';

interface TeamSelectionProps {
  team: Team;
}

export const TeamSelection: FC<TeamSelectionProps> = props => {
  const {team} = props;
  const [selected] = useStringArrayQueryString(team, []);
  const champions = useMemo(() => {
    return [...new Array(5)].map((_, i) => CHAMPIONS.find(c => c.label === selected[i]));
  }, [selected]);
  return (
    <Wrapper>
      {champions.map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <CardWrapper key={i}>
          <ChampionCard team={team} champion={champions[i]} showRemove showHighlight />
        </CardWrapper>
      ))}
    </Wrapper>
  );
};

TeamSelection.displayName = 'TeamSelection';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  padding-bottom: 0;
`;

const CardWrapper = styled.div`
  background-color: #ffffff22;
  border-radius: 8px;
  flex-shrink: 0;
  flex-grow: 1;
  width: 0;
  flex-basis: 1;
`;
